import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError as observableThrowError} from 'rxjs';
import { IAssessment } from '../interfaces/iassessment';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  private _paymentHistory: Array<Ipayement>;
  private _assessmentHistory: Array<IAssessment>;
  private _filingHistorys: Array<IFiling>;

  private BASE_URL:string = window["cfgApiBaseUrl"];
  private PAYMENT_HIST_URL:string = this.BASE_URL+"payment?tpno=";
  private FILE_HIST_URL:string = this.BASE_URL+"filing?tpno=";
  private ASSESSMENT_HIST_URL:string = this.BASE_URL+"assessment?tpno=";
 
 
  constructor(private http : HttpClient) { }

  public get assessmentHistory(): Array<IAssessment> {
    return this._assessmentHistory;
  }

  public get paymentHistory(): Array<Ipayement> {
    return this._paymentHistory;
  }

  public get filingHistorys(): Array<IFiling> {
    return this._filingHistorys;
  } 

  public getPaymentHistorys(tpno : number):Observable<any>{
    return this.http.get<any>(this.PAYMENT_HIST_URL+tpno).pipe(
      map( res =>{
        this._paymentHistory = res;
        return true;
      }),
      catchError(this.errorHandler));
  }

  public getAssessmentHistorys(tpno : number):Observable<any>{
    return this.http.get<any>(this.ASSESSMENT_HIST_URL+tpno).pipe(
      map( res =>{
        this._assessmentHistory = res;
        return true;
      }),
      catchError(this.errorHandler));
  }

  public getFilingHistorys(tpno : number):Observable<any>{
    return this.http.get<any>(this.FILE_HIST_URL+tpno).pipe(
      map( res =>{
        this._filingHistorys = res;
        return true;
      }),
      catchError(this.errorHandler));
  }

  errorHandler(error : HttpErrorResponse){
    return observableThrowError(error.message || "Server Error");
  }
}
